<template>
  <div>
    <Chart :cdata="cdata" :tabname="tabnames" />
  </div>
</template>

<script>
import Chart from './chart.vue'
export default {
  data () {
    return {
      cdata: [],
      tabnames:[],
    }
  },
  components: {
    Chart,
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>